import { render, staticRenderFns } from "./homeFour.vue?vue&type=template&id=5b39c89d&scoped=true"
import script from "./homeFour.vue?vue&type=script&lang=js"
export * from "./homeFour.vue?vue&type=script&lang=js"
import style0 from "./homeFour.vue?vue&type=style&index=0&id=5b39c89d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39c89d",
  null
  
)

export default component.exports